import { Alert, Grid, Typography } from '@mui/material'
import React from 'react'
import { Strings, useStrings } from '../../assets/localization/strings'
import { VideoFeature } from '../../models/GeneralTypes'
import { Pricing, usePricingContext } from '../../reusableUtils/pricing'
import ReactHookFormRadioCardGroupFullImage from '../common/form/ReactHookFormRadioCardGroupFullImage'
import { ContentOptions } from './CampaignTask'
import { getVideoUrl } from '../../config'
import rootStore from '../../stores/rootStore'

const videoWithSubtitle = getVideoUrl('featureSubtitles', rootStore)
const videoWithLogo = getVideoUrl('featureLogo', rootStore)

export const getVideoFeatureOptions = (strings: Strings, pricing: Pricing, currentEdit: VideoFeature[] = []) => {
  return [
    {
      content: videoWithSubtitle,
      showControls: true,
      title: 'Classic Subtitle',
      value: VideoFeature.small,
      description: strings.video_feature_small_description,
      price: pricing[VideoFeature.small],
      disabled: currentEdit.includes(VideoFeature.small) || currentEdit.includes(VideoFeature.medium) || currentEdit.includes(VideoFeature.up_small_medium)
    },
    {
      content: videoWithLogo,
      showControls: true,
      title: 'Premium Subtitle',
      value: currentEdit.includes(VideoFeature.small) ? VideoFeature.up_small_medium : VideoFeature.medium,
      description: strings.video_feature_medium_description,
      price: pricing[currentEdit.includes(VideoFeature.small) ? VideoFeature.up_small_medium : VideoFeature.medium],
      topBadge: strings.most_popular,
      disabled: currentEdit.includes(VideoFeature.medium) || currentEdit.includes(VideoFeature.up_small_medium)
    }
  ]
}

const CampaignAdditionalFeatures = () => {
  const strings = useStrings()
  const pricing = usePricingContext()
  const ctaData = [
    {
      value: 1,
      title: '1 CTA',
      description: strings.campaign_creation_cta_one_desc,
      price: strings.inclusive
    },
    {
      value: 2,
      title: '+1 CTA',
      description: strings.campaign_creation_cta_two_desc,
      price: 29.0
    },
    {
      value: 3,
      title: '+2 CTA',
      description: strings.campaign_creation_cta_three_desc,
      price: 58.0
    }
  ]

  return (
    <Grid container>
      <Grid item xs={12} mt={2}>
        <Typography variant='h5' sx={{ fontSize: '18px', fontFamily: 'Bricolage Grotesque', fontWeight: 500 }}>
          {strings.campaign_creation_video_features_title}
        </Typography>
      </Grid>
      <Grid item xs={12} mt={2}>
        <Alert severity='info'>{strings.campaign_creation_video_features_info}</Alert>
      </Grid>
      <Grid item xs={12} mt={2}>
        <div style={{ borderStyle: 'solid', borderWidth: '1px', borderRadius: '16px', borderColor: '#17181B33', padding: '15px' }}>
          <ReactHookFormRadioCardGroupFullImage name='videoFeature' options={getVideoFeatureOptions(strings, pricing).filterNotNull()} required={false} md={6} />
        </div>
        {/* Reused Hooks component for CTA due to the design is identical  */}
        <ContentOptions optionName='numberOfCtas' data={ctaData} />
      </Grid>
    </Grid>
  )
}

export default CampaignAdditionalFeatures
